var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _radialGradient2, _radialGradient3, _linearGradient7, _linearGradient8, _radialGradient4, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _path, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _ellipse2, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPercentage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 161.714,
    cy: 120.347,
    gradientUnits: "userSpaceOnUse",
    r: 332.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffce3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffae2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.404,
    x2: 32.374,
    y1: 245.628,
    y2: 35.598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.925,
    x2: 214.763,
    y1: 178.074,
    y2: -8.99
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.17,
    x2: 520.486,
    y1: 192.255,
    y2: -51.975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.846,
    x2: 499.971,
    y1: 253.987,
    y2: 367.086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.333,
    x2: 391.66,
    y1: 356.265,
    y2: 170.281
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.705,
    x2: 554.555,
    y1: 345.765,
    y2: 143.319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 275.536,
    cy: 256.977,
    gradientUnits: "userSpaceOnUse",
    r: 121.766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5053,
    stopColor: "#c3272c",
    stopOpacity: 0.495
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#ca2729",
    stopOpacity: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#d52724",
    stopOpacity: 0.183
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9211,
    stopColor: "#e6281c",
    stopOpacity: 0.079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_9_",
    cx: 242.863,
    cy: 265.774,
    gradientUnits: "userSpaceOnUse",
    r: 241.633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.106,
    x2: 148.981,
    y1: 423.52,
    y2: 243.818
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.949,
    x2: 548.482,
    y1: 423.438,
    y2: 179.648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 257.296,
    cy: 280.107,
    gradientUnits: "userSpaceOnUse",
    r: 123.214
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8532,
    stopColor: "#0469bc",
    stopOpacity: 0.147
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc",
    stopOpacity: 0
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 113.212,
    x2: 372.514,
    y1: 245.668,
    y2: 245.668
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.174,
    x2: 131.447,
    xlinkHref: "#lg1",
    y1: 246.919,
    y2: 185.343
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.863,
    x2: 242.863,
    xlinkHref: "#lg1",
    y1: 206.711,
    y2: 134.32
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.404,
    x2: 561.513,
    xlinkHref: "#lg2",
    y1: 267.222,
    y2: 116.424
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.854,
    x2: 105.711,
    xlinkHref: "#lg2",
    y1: 268.455,
    y2: 160.383
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.446,
    x2: 201.48,
    xlinkHref: "#lg2",
    y1: 278.585,
    y2: 232.088
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.234,
    x2: 239.79,
    xlinkHref: "#lg2",
    y1: 315.883,
    y2: 266.245
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555a66"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 189.944,
    x2: 221.779,
    xlinkHref: "#lg3",
    y1: 207.802,
    y2: 356.086
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.111,
    x2: 264.947,
    xlinkHref: "#lg3",
    y1: 198.534,
    y2: 346.819
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.655,
    x2: 307.49,
    xlinkHref: "#lg3",
    y1: 189.4,
    y2: 337.686
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m242.863 245.668-118.002 206.693c-1.343 2.352-4.353 3.113-6.677 1.723-73.111-43.737-118.184-122.99-118.184-208.416 0-133.231 109.632-242.863 242.863-242.863 131.583 0 240.148 106.938 242.813 237.932.055 2.702-2.107 4.931-4.81 4.931z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m242.863 245.668-112.677 197.367c-70.969-40.323-114.514-115.743-114.514-197.367 0-124.633 102.558-227.191 227.191-227.191s227.191 102.558 227.191 227.191z",
    fill: "url(#SVGID_2_)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.863,
    cy: 110.039,
    fill: "url(#SVGID_3_)",
    rx: 147.367,
    ry: 85.658
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m351.732 28.892c16.233 32.575 25.384 69.298 25.384 108.166 0 39.043-9.228 75.926-25.598 108.61h134.208c0-1.896-.029-3.785-.073-5.671-.01-.412-.022-.823-.033-1.234-2.603-91.3-56.638-170.657-133.888-209.871z",
    fill: "url(#SVGID_4_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m458.08 410.246c31.858-40.464 51.139-91.294 51.919-146.604.027-1.923-1.544-3.494-3.467-3.494h-226.894c-4.163 0-6.015 5.231-2.78 7.851l176.335 142.777c1.493 1.21 3.699.98 4.887-.53z",
    fill: "url(#SVGID_5_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m509.847 269.377h-196.28c-4.163 0-6.015 5.231-2.78 7.851l153.718 124.465c26.964-37.521 43.499-83.036 45.342-132.316z",
    fill: "url(#SVGID_6_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m506.532 260.148h-17.871c-9.087 16.343-20.217 31.888-33.416 46.271-19.831 21.61-42.676 38.799-67.296 51.531l65.242 52.826c1.493 1.209 3.699.98 4.888-.53 31.858-40.464 51.139-91.294 51.919-146.604.029-1.923-1.543-3.494-3.466-3.494z",
    fill: "url(#SVGID_7_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m434.766 260.144c-2.89 38.843-17.292 74.469-39.823 103.473l-118.088-95.619c-3.23-2.614-1.382-7.854 2.777-7.854z",
    fill: "url(#SVGID_8_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m246.538 268.846-115.637 202.563c-1.232 2.158-.433 4.89 1.747 6.084 34.578 18.934 74.264 29.703 116.466 29.703 74.582 0 141.3-33.629 185.85-86.539 1.602-1.903 1.358-4.743-.576-6.308l-181.234-146.746c-2.117-1.714-5.266-1.122-6.616 1.243z",
    fill: "url(#SVGID_9_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m249.115 507.195c72.502 0 137.567-31.785 182.066-82.164l-170.487-138.041c-2.117-1.714-5.266-1.123-6.617 1.243l-111.077 194.577c32.063 15.604 68.058 24.385 106.115 24.385z",
    fill: "url(#SVGID_10_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m434.389 414.348-57.159-46.281c-45.422 64.381-120.375 106.436-205.157 106.436-13.972 0-27.671-1.161-41.021-3.357l-.15.263c-1.232 2.158-.433 4.89 1.747 6.084 34.578 18.934 74.264 29.702 116.466 29.702 74.582 0 141.3-33.629 185.85-86.539 1.602-1.903 1.357-4.743-.576-6.308z",
    fill: "url(#SVGID_11_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m385.556 374.801c-35.211 38.881-86.106 63.31-142.693 63.31-29.494 0-57.429-6.635-82.411-18.486l86.081-150.786c1.357-2.362 4.499-2.953 6.623-1.232z",
    fill: "url(#SVGID_12_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 242.863,
    cy: 245.668,
    fill: "url(#SVGID_13_)",
    r: 129.651
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.863,
    cy: 245.668,
    fill: "url(#SVGID_14_)",
    r: 121.284
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.863,
    cy: 173.263,
    fill: "url(#SVGID_15_)",
    rx: 78.671,
    ry: 45.728
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m300.86 129.691c8.744 17.452 13.673 37.147 13.673 57.996 0 71.604-58.047 129.651-129.65 129.651-20.849 0-40.544-4.929-57.997-13.673 21.287 42.485 65.222 71.654 115.977 71.654 71.604 0 129.65-58.046 129.65-129.65 0-50.756-29.169-94.691-71.653-115.978z",
    fill: "url(#SVGID_16_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m356.183 308.676c-15.444 27.747-40.791 49.211-71.252 59.653l-77.234-77.234c-24.04-24.04-42.651-42.638-42.751-42.739-6.132-5.064-9.199-13.069-9.199-24.002v-33.251c0-10.92 3.066-18.925 9.199-24.002 6.132-5.077 14.426-7.615 24.869-7.615 10.367 0 18.674 2.538 24.932 7.615l35.324 35.362z",
    fill: "url(#SVGID_17_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m372.507 245.668c0 22.871-5.919 44.36-16.324 63.009-15.444 27.747-40.791 49.211-71.252 59.653-13.195 4.536-27.345 6.987-42.073 6.987-3.694 0-7.351-.151-10.958-.465l-37.624-37.272c-2.501-2.576-3.745-5.429-3.745-8.545 0-1.408.377-2.89 1.144-4.449l16.022-33.49 42.374-88.632 22.343-46.722c1.835-3.896 5.052-5.856 9.664-5.856 3.431 0 6.597 1.169 9.488 3.519 1.294 1.043 2.287 2.237 3.003 3.531l77.448 77.46c.327 3.719.49 7.476.49 11.272z",
    fill: "url(#SVGID_18_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m320.601 242.507c-6.253-5.072-14.563-7.611-24.929-7.611-10.451 0-18.742 2.54-24.875 7.611-6.133 5.075-9.199 13.077-9.199 24.003v33.254c0 10.929 3.066 18.932 9.199 24.003.101.084 14.916 14.892 35.178 35.153 21.046-11.749 38.488-29.178 50.213-50.244 3.739-6.7 6.887-13.772 9.401-21.138z",
    fill: "url(#SVGID_19_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m224.128 224.357v-33.254c0-10.926-3.128-18.928-9.378-24.003-6.253-5.072-14.563-7.611-24.929-7.611-10.451 0-18.742 2.54-24.875 7.611-6.133 5.075-9.199 13.077-9.199 24.003v33.254c0 10.929 3.066 18.932 9.199 24.003 6.133 5.075 14.424 7.611 24.875 7.611 10.365 0 18.676-2.536 24.929-7.611 6.25-5.071 9.378-13.074 9.378-24.003zm-22.481 0c0 7.493-3.944 11.24-11.826 11.24-7.728 0-11.593-3.747-11.593-11.24v-33.254c0-7.494 3.865-11.24 11.593-11.24 7.882 0 11.826 3.747 11.826 11.24z",
    fill: "url(#SVGID_20_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m295.905 162.299c0-3.589-1.445-6.557-4.336-8.898-2.891-2.342-6.056-3.512-9.492-3.512-4.603 0-7.823 1.954-9.66 5.854l-80.738 168.844c-.769 1.563-1.148 3.044-1.148 4.449 0 3.121 1.251 5.972 3.754 8.548 2.503 2.575 5.631 3.863 9.385 3.863 5.057 0 8.507-1.954 10.352-5.854l80.964-168.844c.611-1.248.919-2.73.919-4.45z",
    fill: "url(#SVGID_21_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m320.6 242.507c-6.253-5.072-14.562-7.611-24.929-7.611-10.451 0-18.742 2.54-24.875 7.611-6.132 5.075-9.198 13.077-9.198 24.003v33.253c0 10.93 3.066 18.933 9.198 24.004 6.133 5.075 14.424 7.61 24.875 7.61 10.367 0 18.676-2.535 24.929-7.61 6.251-5.072 9.379-13.074 9.379-24.004v-33.253c0-10.926-3.129-18.929-9.379-24.003zm-13.103 57.256c0 7.495-3.944 11.241-11.826 11.241-7.728 0-11.593-3.747-11.593-11.241v-33.253c0-7.493 3.865-11.241 11.593-11.241 7.882 0 11.826 3.748 11.826 11.241z",
    fill: "url(#SVGID_22_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPercentage);
export default __webpack_public_path__ + "static/media/icon-percentage.8e3d7e7089c33690f269b606bd36c989.svg";
export { ForwardRef as ReactComponent };